import axios from "axios"
import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { Col, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import MultipleValueTextInput from "react-multivalue-text-input"
import { useHistory } from "react-router-dom"
import ReactSwitch from "react-switch"

const FilterTawuniyaProjectsData = ({
  filteredValues,
  setFilteredValues,
  setAuth,
  userPermissions,
}) => {
  // console.log("filteredValues ------------->", filteredValues)

  const history = useHistory()

  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange

  const [uploadDateRange, setUploadDateRange] = useState([null, null])
  const [uploadStartDate, uploadEndDate] = uploadDateRange

  const convertDate = value => {
    let day = value.getDate() + ""
    day = day.length === 1 ? `0${day}` : day
    let month = value.getMonth() + 1 + ""
    month = month.length === 1 ? `0${month}` : month
    let year = value.getFullYear()
    return `${year}-${month}-${day}` || null
  }

  const formData = {
    PerToken: localStorage.getItem("token"),
    PerUserID: localStorage.getItem("id"),
    PerRoleID: localStorage.getItem("userRoleID"),
  }

  useEffect(() => {
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/inspection/TransferToList.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log(res.data)
      })
      .catch(err => console.log(err))
  }, [])

  const uploadStatusOptions = [
    { value: "0", label: "Waiting" },
    { value: "1", label: "Uploaded" },
  ]

  return (
    <Row className="">
      {/* *************************** Policy No ****************************  */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
            <i className="bx bx-search-alt search-icon" />
            <MultipleValueTextInput
              onItemAdded={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  policyNo: allItems,
                })
              }
              onItemDeleted={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  policyNo: allItems,
                })
              }
              type="number"
              name="policyNo"
              placeholder="Policy No ..."
              className="border-0 mt-1"
              values={filteredValues.policyNo}
            />
          </div>
        </div>
      </Col>

      {/* *************************** Upload Status **************************** */}
      <Col sm={3}>
        <div className="search-box me-3 col-12 p-0">
          <div className="position-relative mb-3 form-control border-dark py-0">
            <i className="bx bx-search-alt search-icon my-auto" />
            <Select
              isMulti
              options={uploadStatusOptions}
              name="uploadStatus"
              className="react-select-container"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused ? "transparent" : "transparent",
                  borderColor: state.isSelected ? "transparent" : "transparent",
                  borderWidth: "0px",
                }),
              }}
              value={filteredValues.uploadStatus}
              onChange={e => {
                // console.log(e)
                setFilteredValues({ ...filteredValues, uploadStatus: e })
              }}
              classNamePrefix="select"
              placeholder="Upload Status ..."
            />
          </div>
        </div>
      </Col>

      {/* *************************** Adding To List Date **************************** */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 d-flex form-control border-dark ">
            <i className="bx bx-search-alt search-icon " />

            <DatePicker
              isClearable
              className="border-0"
              selectsRange={true}
              dateFormat="yyyy/MM/dd"
              startDate={startDate}
              endDate={endDate}
              onChange={update => {
                setDateRange(update)
                setFilteredValues({
                  ...filteredValues,
                  startDate: update[0] ? convertDate(update[0]) : null,
                  endDate: update[1] ? convertDate(update[1]) : null,
                })
              }}
              // withPortal
              placeholderText="Adding To List Date ..."
            />
          </div>
        </div>
      </Col>

      {/* *************************** Upload Date **************************** */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 d-flex form-control border-dark ">
            <i className="bx bx-search-alt search-icon " />

            <DatePicker
              isClearable
              className="border-0"
              selectsRange={true}
              dateFormat="yyyy/MM/dd"
              startDate={uploadStartDate}
              endDate={uploadEndDate}
              onChange={update => {
                setUploadDateRange(update)
                setFilteredValues({
                  ...filteredValues,
                  uploadStartDate: update[0] ? convertDate(update[0]) : null,
                  uploadEndDate: update[1] ? convertDate(update[1]) : null,
                })
              }}
              // withPortal
              placeholderText="Upload Date ..."
            />
          </div>
        </div>
      </Col>

      {/* *************************** Survey No **************************** */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
            <i className="bx bx-search-alt search-icon" />
            <MultipleValueTextInput
              disabled={filteredValues.projectNoType?.value === "ref"}
              onItemAdded={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  surveyNo: allItems,
                })
              }
              onItemDeleted={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  surveyNo: allItems,
                })
              }
              type="number"
              name="surveyNo"
              placeholder="Survey No ..."
              className="border-0 mt-1"
              values={filteredValues.surveyNo}
            />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default FilterTawuniyaProjectsData
